<template>
    <div id="drugordersInbox">
        <MdTitle
            :Text="
                `Fill Order -
                   ${this.medications.drugName} -
                   Quantity Ordered ${!CanFill ? 0 : InfoHeader.qtyOrdered} ${this.medications.form}
                   <span class='highlightInTitle blueTitle text-uppercase'>${
                       medications.internalStatusTranslated
                   }</span>`
            "
        />

        <div
            class="alert alert-fill-warning d-flex align-items-center m-3"
            role="alert"
            v-if="isReadOnly"
        >
            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
            <div class="flex-grow-1">
                <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
            </div>
        </div>

        <div
            class="alert alert-fill-warning d-flex align-items-center m-3"
            role="alert"
            v-if="!CanFill"
        >
            <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
            <div class="flex-grow-1">
                {{ MessageNoFillOrder }}
            </div>
        </div>

        <div class="grid-margin stretch-card">
            <div class="card activeCard">
                <div class="card-body">
                    <div class="d-flex align-items-start justify-content-between">
                        <h6
                            v-b-toggle="'OrdertoFill'"
                            class="card-title flex-grow lower-line text-truncate"
                        >
                            {{ $t('DrugOrdersInboxFill.OrderToFill') }}
                        </h6>
                        <i
                            class="mdi mdi-arrow-right-drop-circle text-corporate"
                            style="cursor: pointer"
                            v-on:click="GotoMedByBox"
                        ></i>
                    </div>

                    <div class="float-left col-md-3 text-muted p-item">
                        <small>{{ $t('Shared.DrugName') }}</small
                        ><br />
                        <b>{{ this.medications.drugName }}</b
                        ><br />
                        <div
                            :class="
                                this.medications.mode === 'STAT'
                                    ? 'DrugOrderType dotSTAT'
                                    : 'DrugOrderType'
                            "
                        >
                            {{ this.medications.mode }}
                        </div>
                        <div
                            v-if="this.medications.drugTypeCode"
                            v-bind:class="
                                this.medications.drugTypeCode === 'C' ||
                                this.medications.drugTypeCode === 'CD' ||
                                this.medications.drugTypeCode === 'SCD'
                                    ? 'DrugOrderType dotCD-SCD'
                                    : 'DrugOrderType'
                            "
                        >
                            {{ this.medications.drugType }}
                        </div>
                        <div v-if="this.medications.isHighAlert" class="DrugOrderType doiHighAlert">
                            {{ $t('Shared.IsHigh') }}
                        </div>
                        <div
                            v-if="this.medications.isLookAlikeSoundAlike"
                            class="DrugOrderType dotLASA"
                        >
                            {{ $t('DrugOrdersInboxFill.LASA') }}
                        </div>                        
                    </div>

                    <div
                        class="float-left col-md-3 text-muted p-item"
                        v-if="this.medications.activeIngred"
                    >
                        <small>{{ $t('Shared.activeIngredients') }}</small
                        ><br />
                        <b>{{ this.medications.activeIngred }}</b>
                    </div>

                    <div
                        class="float-left col-md-3 text-muted p-item"
                        v-if="this.medications.drugCode"
                    >
                        <small>{{ $t('Shared.DrugCode') }}</small
                        ><br />
                        <b>{{ this.medications.drugCode }}</b>
                    </div>

                    <div
                        class="float-left col-md-3 text-muted p-item"
                        v-if="this.medications.quantityOrdered"
                    >
                        <small>{{ $t('modalMarsMed.QuantityOrdered') }}</small
                        ><br />
                        <b>{{ this.medications.quantityOrdered }} {{ this.medications.form }}</b>
                    </div>
                </div>
            </div>
        </div>

        <div class="FillOrder mb-1">
            <MdTitle
                v-bind:Text="'Fill Information'"
                v-bind:isSubtitle="true"
                v-bind:Name="'T_TitleSearch'"
            />

            <b-row v-if="CanFill">
                <b-col md="2" sm="12">
                    <MdSelect
                        v-bind:Label="$t('DrugOrdersInbox.PharmacyLocation')"
                        v-bind:Options="LocationList"
                        v-bind:FieldDescription="'name'"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="ModelLocation"
                        v-bind:AllowEmpty="false"
                        v-bind:IsDisabled="isReadOnly || !CanFill"
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownLocation"
                        v-bind:Name="'location_select'"
                        id="location_select"
                    />
                </b-col>

                <b-col md="2" sm="12">
                    <div :data-label="$t('modalMarsMed.QuantityOrdered')" class="textlabel">
                        <span class="noInput"
                            ><b>{{ InfoHeader.qtyOrdered }}</b></span
                        >
                    </div>
                </b-col>

                <b-col md="2" sm="12">
                    <div :data-label="$t('DrugOrdersInbox.Availability')" class="textlabel">
                        <span class="noInput"
                            ><b>{{ InfoHeader.qtyAvailable }}</b></span
                        >
                    </div>
                </b-col>

                <b-col md="2" sm="12">
                    <div :data-label="$t('DrugOrdersInbox.PrevFilled')" class="textlabel">
                        <span class="noInput"
                            ><b>{{ InfoHeader.qtyPreviouslyUsed }}</b></span
                        >
                    </div>
                </b-col>
                <b-col md="2" sm="12">
                    <div :data-label="$t('DrugOrdersInbox.ToFill')" class="textlabel">
                        <span class="noInput"
                            ><b>{{ InfoHeader.qtyToFill }}</b></span
                        >
                    </div>
                </b-col>
                <b-col md="2" sm="12">
                    <div :data-label="$t('Shared.Filled')" class="textlabel">
                        <span class="noInput"
                            ><b>{{ TotalQtyToFill }}</b></span
                        >
                    </div>
                </b-col>
            </b-row>

            <div class="groupscroll" v-if="this.medications.internalStatus !== 'FILLED'">
                <div
                    v-if="showEmptyRecords"
                    v-bind:style="emptyRecordsStyle"
                    role="alert"
                    aria-live="polite"
                >
                    <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                </div>

                <div v-for="(item, index) in OrderDetail" :key="index" class="w-100">
                    <b-row class="groupingRow">
                        <b-col lg="1" md="1" sm="12">
                            <MdEdit
                                v-bind:Label="$t('DrugOrdersInboxFill.QTYtofill')"
                                v-bind:TypeProp="'number'"
                                v-bind:Min="'0'"
                                v-bind:Max="item.max"
                                v-bind:isReadOnly="isReadOnly || !CanFill || !!item.expirationInfo"
                                v-bind:Name="'input_QTYtofill' + index"
                                v-model.number="item.qtyToFill"
                                v-on:change="onChangeToFill('input_QTYtofill' + index, item)"
                                @blur="
                                    blurQTYToFill(
                                        item.qtyToFill,
                                        item.qtyAvailable,
                                        'input_QTYtofill' + index,
                                        item
                                    )
                                "
                                v-bind:Id="'input_QTYtofill' + index"
                            >
                            </MdEdit>
                        </b-col>
                        <b-col lg="1" md="1" sm="12">
                            <MdEdit
                                v-bind:Label="$t('DrugOrdersInboxFill.Lot')"
                                v-bind:TypeProp="'text'"
                                v-bind:Name="'Lot'"
                                v-bind:isReadOnly="true"
                                v-model="item.lotNo"
                                v-bind:Id="'input_Lot' + index"
                            >
                            </MdEdit>
                        </b-col>
                        <b-col lg="1" md="1" sm="12">
                            <MdEdit
                                v-bind:Label="$t('Shared.Received')"
                                v-bind:TypeProp="'text'"
                                v-bind:Name="'QTYReceived'"
                                v-bind:isReadOnly="true"
                                v-model="item.quantity"
                                v-bind:Id="'input_QTYReceived' + index"
                            >
                            </MdEdit>
                        </b-col>
                        <b-col lg="1" md="1" sm="12">
                            <MdEdit
                                v-bind:Label="$t('Shared.Available')"
                                v-bind:TypeProp="'text'"
                                v-bind:Name="'QTYAvailable'"
                                v-bind:isReadOnly="true"
                                v-model="item.qtyAvailable"
                                v-bind:Id="'input_QTYAvailable' + index"
                            >
                            </MdEdit>
                        </b-col>
                        <b-col lg="1" md="1" sm="12">
                            <MdEdit
                                v-bind:Label="$t('DrugOrdersInboxFill.PrevUsed')"
                                v-bind:TypeProp="'text'"
                                v-bind:Name="'PrevUsed'"
                                v-bind:isReadOnly="true"
                                v-model="item.qtyPreviouslyUsed"
                                v-bind:Id="'input_PrevUsed' + index"
                            >
                            </MdEdit>
                        </b-col>
                        <b-col lg="2" md="2" sm="12">
                            <MdEdit
                                v-bind:Label="$t('Shared.ExpirationDate')"
                                v-bind:TypeProp="'text'"
                                v-bind:Name="'ExpDate'"
                                v-bind:isReadOnly="true"
                                v-model="item.expirationDate"
                                v-bind:Id="'input_ExpDate' + index"
                            >
                            </MdEdit>
                        </b-col>
                        <b-col lg="5" md="5" sm="12">
                            <MdEdit
                                v-bind:Label="$t('DrugOrdersInboxFill.ExpInfo')"
                                v-bind:TypeProp="'text'"
                                v-bind:Name="'ExpInfo'"
                                v-bind:isReadOnly="true"
                                v-model="item.expirationInfo"
                                v-bind:Id="'input_ExpInfo' + index"
                            >
                            </MdEdit>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <div
                class="groupscroll"
                v-if="!CanFill && this.medications.internalStatus === 'FILLED'"
            >
                <div
                    v-if="showEmptyRecords"
                    v-bind:style="emptyRecordsStyle"
                    role="alert"
                    aria-live="polite"
                >
                    <div class="text-center my-2">{{ $t('MdTable.nRecShow') }}</div>
                </div>
                <div v-for="(item, index) in OrderDetail" :key="index" class="w-100">
                    <b-row class="groupingRow">
                        <b-col lg="2" md="2" sm="12">
                            <MdEdit
                                v-bind:Label="$t('Shared.Filled')"
                                v-bind:TypeProp="'number'"
                                v-bind:isReadOnly="true"
                                v-bind:Name="'QTYtofill'"
                                v-model="item.qtyFilled"
                                v-bind:Id="'input_QTYtofill' + index"
                            >
                            </MdEdit>
                        </b-col>
                        <b-col lg="2" md="2" sm="12">
                            <MdEdit
                                v-bind:Label="$t('DrugOrdersInboxFill.Lot')"
                                v-bind:TypeProp="'text'"
                                v-bind:Name="'Lot'"
                                v-bind:isReadOnly="true"
                                v-model="item.lotNo"
                                v-bind:Id="'input_Lot' + index"
                            >
                            </MdEdit>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>

        <b-row>
            <b-col lg="12" md="12" sm="12">
                <MdMemo
                    v-bind:Label="$t('Shared.PharmacistNotes')"
                    v-bind:Name="'PharmacyNotesFill'"
                    v-bind:Rows="'5'"
                    v-bind:MaxRows="'6'"
                    v-bind:MaxLength="'500'"
                    v-bind:VisibleLabel="true"
                    v-model="PharmacyNoteFill"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.PatientInfo')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <div class="IncidentContainerBox noNum mt-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                        <div class="card activeCard">
                            <div class="card-body">
                                <div class="d-flex align-items-start justify-content-between">
                                    <h6
                                        v-b-toggle="'InfoBoxs'"
                                        class="card-title flex-grow lower-line text-truncate"
                                    >
                                        {{ patientInfo.patientName }} - {{ PatientCode }} -
                                        {{ $t('Shared.Dob') }} {{ patientInfo.dob }}
                                        {{ patientInfo.ageFormatted }} -
                                        {{ $t('Shared.Weight') + label('Weightlbs') }}
                                        {{ patientInfo.weight }} -
                                        {{ $t('Shared.Height') + label('Heightft') }}
                                        {{ patientInfo.heights }}
                                    </h6>
                                    <b-button
                                        v-on:click="DoReport()"
                                        style="position: relative; top: -4px;"
                                        class="repDateNotesBtn mx-2"
                                        v-b-tooltip.hover
                                        :title="$t('MdPatientInfoBox.CurrentFaceSheet')"
                                    >
                                        {{ $t('Shared.FS') }}
                                    </b-button>
                                </div>

                                <b-collapse visible id="InfoBoxs" class="small-info ml-2"
                                    ><small>{{
                                        $t('modalMarsMed.clickTitleTextPatient')
                                    }}</small></b-collapse
                                >
                                <b-collapse id="InfoBoxs">
                                    <div class="card activeCard">
                                        <div class="container-mars">
                                            <div class="card-container">
                                                <div class="card-body">
                                                    <div class="row patPhoto-container">
                                                        <div class="col-md-1 patPhoto">
                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        !patientInfo.specialPrecautions &&
                                                                        !patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        !patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t(
                                                                        'Shared.PatientSpecialPrecautions'
                                                                    )}: ` +
                                                                        patientInfo.specialPrecautions
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !patientInfo.allergies &&
                                                                        !patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('Shared.MarsAlerts')}: ` +
                                                                        patientInfo.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        !patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies +
                                                                        ` / ` +
                                                                        $t(
                                                                            'Shared.PatientSpecialPrecautions'
                                                                        ) +
                                                                        ': ' +
                                                                        patientInfo.specialPrecautions
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        !patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        patientInfo.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    !patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t(
                                                                        'Shared.PatientSpecialPrecautions'
                                                                    )}: ` +
                                                                        patientInfo.specialPrecautions +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        patientInfo.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <i
                                                                id="rm-allergic"
                                                                v-if="
                                                                    patientInfo.allergies &&
                                                                        patientInfo.specialPrecautions &&
                                                                        patientInfo.marsAlerts
                                                                "
                                                                class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                                v-b-tooltip.hover="
                                                                    `${$t('RigthBar.ALLERGIC')}: ` +
                                                                        patientInfo.allergies +
                                                                        ' / ' +
                                                                        `${$t(
                                                                            'Shared.PatientSpecialPrecautions'
                                                                        )}: ` +
                                                                        patientInfo.specialPrecautions +
                                                                        ` / ` +
                                                                        $t('Shared.MarsAlerts') +
                                                                        ': ' +
                                                                        PhotoObj.marsAlerts
                                                                "
                                                                variant="primary"
                                                            >
                                                            </i>

                                                            <img
                                                                v-if="patientInfo.contents"
                                                                v-bind:src="
                                                                    'data:image/' +
                                                                        '.' +
                                                                        patientInfo.extension +
                                                                        ';base64,' +
                                                                        patientInfo.contents
                                                                "
                                                                alt="Foto"
                                                                class="patPic img-fluid"
                                                                style="height: 100%;"
                                                            />

                                                            <img
                                                                v-else-if="
                                                                    (patientInfo.contents ===
                                                                        null ||
                                                                        patientInfo.contents ===
                                                                            '') &&
                                                                        patientInfo.sex === 'F'
                                                                "
                                                                src="@/assets/images/faces/nopic-female.jpg"
                                                                alt="Foto"
                                                                class="photo img-fluid"
                                                            />

                                                            <img
                                                                v-else
                                                                src="@/assets/images/faces/nopic-male.jpg"
                                                                alt="Foto"
                                                                class="photo img-fluid"
                                                            />
                                                        </div>
                                                        <div class="col-md-11">
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.PatientName')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        patientInfo.patientName
                                                                    }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.PatientCode')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ PatientCode }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Dob')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.dob }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Age')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        patientInfo.ageFormatted
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Gender')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.sex }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Weight') +
                                                                            label('Weightlbs')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.weight }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $t('Shared.Height') +
                                                                            label('Heightft')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{ patientInfo.heights }}</b>
                                                                </div>
                                                                <div
                                                                    class="col-md-3 text-muted p-item"
                                                                >
                                                                    <small>{{
                                                                        $tc('Shared.Program')
                                                                    }}</small
                                                                    ><br />
                                                                    <b>{{
                                                                        medications.programName
                                                                    }}</b>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <MdPatientAllergies
                                            v-if="PatientCode"
                                            v-bind:NoUseClass="false"
                                            v-bind:ModalIdAddAllergy="'AddAllergyMars'"
                                            v-bind:VisibleAllergy="true"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                            v-bind:NoValidateChanges="true"
                                        >
                                        </MdPatientAllergies>
                                        <MdPatientSpecialPrecautions
                                            v-if="PatientCode"
                                            v-bind:NoUseClass="false"
                                            v-bind:ModalIdAddSpecialPrecautions="
                                                'AddSpecialPrecautionMarsMed'
                                            "
                                            v-bind:VisibleSpecialPrecautions="true"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                            v-bind:NoValidateChanges="true"
                                        >
                                        </MdPatientSpecialPrecautions>
                                        <MdPatientMarsAlert
                                            v-if="PatientCode"
                                            v-bind:UseColumnDynamic="true"
                                            v-bind:ModalIdAddMarksAlert="'ModalMarsAlert'"
                                            v-bind:VisibleMarsAlert="true"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                        >
                                        </MdPatientMarsAlert>
                                        <MdPatientDiagnosis
                                            v-if="PatientCode"
                                            v-bind:UseColumnDinamic="true"
                                            v-bind:VisibleDiagnosis="true"
                                            v-bind:ModalIdDiagnosis="'ModalIdDiagMarsMed'"
                                            v-bind:Column="'col-md-3'"
                                            v-bind:PatientCode="PatientCode.trim()"
                                        >
                                        </MdPatientDiagnosis>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <MdTitle
            v-bind:Text="$t('Medication.PatMedications')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <div class="IncidentContainerBox noNum mt-2">
            <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                        <div class="card activeCard">
                            <div class="card-body">
                                <div class="d-flex align-items-start justify-content-between">
                                    <h6
                                        v-b-toggle="'InfoMed'"
                                        class="card-title flex-grow lower-line text-truncate"
                                    >
                                        {{ $t('DrugOrdersInbox.ViewAllMed') }}
                                    </h6>
                                </div>
                                <b-collapse visible id="InfoMed" class="small-info ml-2"
                                    ><small>{{
                                        $t('modalMarsMed.clickTitleTextPatient')
                                    }}</small></b-collapse
                                >
                                <b-collapse id="InfoMed">
                                    <div class="card activeCard">
                                        <div class="container-mars">
                                            <div class="card-container">
                                                <div class="card-body">
                                                    <b-row>
                                                        <div class="col-sm-12 col-md-3">
                                                            <MdSelect
                                                                v-bind:Label="
                                                                    $t('Medication.RxStatus')
                                                                "
                                                                v-bind:Options="RxStatusList"
                                                                v-bind:FieldDescription="'name'"
                                                                v-bind:FieldCode="'value'"
                                                                v-bind:Model="ModelRxStatus"
                                                                v-bind:Multiple="false"
                                                                :Input="ChangeDropDownRxStatus"
                                                                v-bind:Name="'rxstatus_select'"
                                                                id="rxtatus_select"
                                                            />
                                                        </div>
                                                        <div class="col-sm-12 col-md-9 mb-4">
                                                            <div
                                                                class="textlabel"
                                                                :data-label="
                                                                    this.$t('Shared.SearchElements')
                                                                "
                                                            >
                                                                <div class="input-group" dir="ltr">
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        :dir="dirInput"
                                                                        v-model="
                                                                            parameter.SearchCriteria
                                                                        "
                                                                        @keyup.enter="
                                                                            getPatientMedications2(
                                                                                medications.patientCode
                                                                            )
                                                                        "
                                                                    />

                                                                    <div class="input-group-append">
                                                                        <MdButton
                                                                            v-bind:Name="
                                                                                'btnsearchinput'
                                                                            "
                                                                            v-bind:VariantProp="
                                                                                'btn btn-sm search-attached'
                                                                            "
                                                                            v-bind:IconClass="
                                                                                'mdi mdi-magnify'
                                                                            "
                                                                            v-on:click="
                                                                                getPatientMedications2(
                                                                                    medications.patientCode
                                                                                )
                                                                            "
                                                                        >
                                                                        </MdButton>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-row>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <MdTable
                                                                v-bind:fields="fields2"
                                                                v-bind:items="items2"
                                                                v-bind:totalRows="totalRows2"
                                                                v-bind:showMessageIsEmpty="
                                                                    ShowMessageIsEmpty
                                                                "
                                                                v-bind:currentPage="currentPage2"
                                                                v-bind:perPage="perPage2"
                                                                v-bind:IsMedicationList="true"
                                                                :viewIconEvent="ViewMed"
                                                                v-bind:pageOptions="pageOptions2"
                                                                :onFiltered="onFiltered2"
                                                                :pageChanged="pageChanged2"
                                                                :onRowSelected="onRowSelected2"
                                                                :otherIcon="'printer-fill'"
                                                                :otherIconEvent="ShowReport"
                                                                :RowClick="RowClicked"
                                                                :perPageFunction="PerPageFunction2"
                                                            >
                                                            </MdTable>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <PatientMedicationsRep
            v-if="isReportVisible"
            :closeWindow="closeParamRepWindow"
            :patientCode="this.PatientCode"
            :recNo="recNoToReport"
        />

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:isReadOnly="posSelected === 0"
                v-bind:Label="'◄'"
                v-bind:Name="'btnBackRec'"
                v-bind:VariantProp="'light'"
                v-bind:TextToolTip="$t('DrugOrdersInbox.BackRecordId')"
                v-on:click="Back"
                v-bind:ClassProp="'mx-2'"
            />

            {{ ShowText }}

            <MdButton
                v-bind:isReadOnly="posSelected === recordsId.length - 1"
                v-bind:Label="'►'"
                v-on:click="Next"
                v-bind:Name="'btnNextRec'"
                v-bind:TextToolTip="$t('DrugOrdersInbox.NextRecordId')"
                v-bind:VariantProp="'light'"
                v-bind:ClassProp="'mx-2'"
            />

            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('Shared.Back')"
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />

            <b-button-group variant="primary" v-if="medications">
                <b-button
                    :disabled="
                        OrderDetail.length === 0 || isReadOnly || !CanFill || TotalQtyToFill === 0
                    "
                    variant="primary"
                    v-on:click="ValidateAll()"
                    >{{ $t('DrugOrdersInboxFill.FillOrder') }}</b-button
                >
                <b-dropdown variant="primary" class="ms-2" id="dropdown-buttons">
                    <b-dropdown-item-button
                        v-if="medications.internalStatus === 'PENDING'"
                        v-on:click="SetStatusHandler('ORDERED')"
                        :disabled="false"
                    >
                        {{ $t('DrugOrdersInboxRightBar.Settoordered') }}
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                        v-if="!ValidateNoChargeable() && ValidateVoided()"
                        v-on:click="updateChargeable('CHARGEABLE')"
                        :disabled="false"
                    >
                        {{ $t('DrugOrdersInboxRightBar.SetToChargeable') }}
                    </b-dropdown-item-button>

                    <b-dropdown-item-button
                        v-if="
                            this.medications.internalStatus === 'FILLED' ||
                                this.medications.internalStatus === 'PARTIALFILLED'
                        "
                        v-on:click="undoFillOrders"
                        :disabled="false"
                    >
                        {{ $t('DrugOrdersInboxRightBar.Undofillorders') }}
                    </b-dropdown-item-button>

                    <b-dropdown-item-button :disabled="false" v-on:click="OpenDrugInfo">
                        {{ $t('Shared.DrugInfo') }}
                    </b-dropdown-item-button>
                    <b-dropdown-item-button v-if="this.$store.state.isUseDrugInboxInteraction" :disabled="false" v-on:click="OpenDrugInteraction">
                        {{ $t('DrugOrdersInboxRightBar.DrugInteraction') }}
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                        v-if="
                            !medications.isPatientOwnMedication &&
                                medications.internalStatus &&
                                (medications.internalStatus.toUpperCase() === 'PENDING' ||
                                    medications.internalStatus.toUpperCase() === 'ORDERED')
                        "
                        :disabled="false"
                        v-on:click="SetStatusHandler('UNABLETOFILL')"
                    >
                        {{ $t('DrugOrdersInboxFill.UnableToFill') }}
                    </b-dropdown-item-button>
                    <b-dropdown-item-button :disabled="false" v-on:click="AddingNotes"
                        >{{ $t('Shared.PharmacistNotes') }}
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                        v-if="
                            medications.internalStatus &&
                                (medications.internalStatus.toUpperCase() === 'FILLED' ||
                                    medications.internalStatus.toUpperCase() === 'PARTIALLYFILLED')
                        "
                        :disabled="false"
                        v-on:click="OpenMedLabel()"
                        >{{ $t('Shared.Printmedlabels') }}</b-dropdown-item-button
                    >
                    <b-dropdown-item-button :disabled="false" v-on:click="Print">
                        {{ $t('Shared.Report') }}
                    </b-dropdown-item-button>
                </b-dropdown>
            </b-button-group>
        </div>

        <MDTextEditorDialog
            :visible="textEditorVisible"
            v-model="textEditorValue"
            @close="closeTextEditorHandler"
            @ok="okTextEditorHandler"
            :handlerOk="undoFillOrdersAsync"
            :required="true"
        >
        </MDTextEditorDialog>

        <ModalDrugOrderMedication
            v-if="VisibleModalViewMed"
            :RecordId="RecordId"
            :PatientCode="PatientCode"
            :isControlledSubstance="isControlledSubstance"
            :isUAE="isNRC"
            @Print="Print"
            :TitleWindow="$t('DrugOrdersInboxFill.MedicationInfo')"
            @OnModalDrugOrderInboxClose="CloseModalMed"
            ModalId="'ModalIdModalViewMedFill'"
        >
        </ModalDrugOrderMedication>

        <DrugOrderNotesDlg
            :visible="addNoteVisible"
            :item="addNoteItem"
            @close="closeHandler"
            @ok="okHandler"
            @ret:comments="setStatusUnableToFillHandler"
            :editable="pharmacyNoteEditable"
        >
        </DrugOrderNotesDlg>

        <DxPopup
            :visible="isReportPatientMedicationVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('PatientMedications.ReportMedications')"
            @hidden="onHiddenMedicationReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
            :wrapper-attr="popupAttributes"
        >
            <ReportViewer
                ref="patientMedications"
                :ReportName="'PatientMedications'"
                :ReportTitle="$t('PatientMedications.ReportMedications')"
                :IsAnAPIReport="true"
            />
        </DxPopup>

        <MedicationLabelsRep
            v-if="isMedicationLabelsRepVisible"
            :closeWindow="closeParamRepWindowMedLabel"
            :codeList="getRecordId()"
        />

        <DxPopup
            :visible="isReportPatientFaceSheetVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="reportTitle"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
        >
            <ReportViewer
                ref="PatientFaceSheetRep"
                :ReportName="'PatientFaceSheet'"
                :ReportTitle="reportTitle"
                :IsAnAPIReport="true"
            />
        </DxPopup>

        <BaseModal
            v-if="DataBankVisible"
            ModalId="ModalDataBank"
            :key="'ModalDataBank'"
            :TitleWindow="
                FirstDataDrugName
                    ? $t('Shared.DrugInfo') + ` - ` + FirstDataDrugName
                    : $t('Shared.DrugInfo')
            "
            :width="'70%'"
            :height="'85vh'"
            :UseUpClass="true"
            :HideModalFun="DataBankOnCancel"
            @Close="DataBankOnCancel"
            :buttons="[{ text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }]"
        >
            <DataBankSearch
                :SearchCriteria.sync="SearchBank"
                :DrugCode="this.DrugCode"
                :PatientCode="this.PatientCode"
                :AdmissionRecordId="AdmissionRecordId"
                @UpdateDataDrugName="UpdateDataDrugName"
            >
            </DataBankSearch>
        </BaseModal>

        <BaseModal
            v-if="SignotecVisible"
            ModalId="SignotecModalId"
            :TitleWindow="`Sign`"
            :width="'30%'"
            :height="'auto'"
            :HideModalFun="SignotecOnCancel"
            @Close="SignotecOnCancel"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.TitleOK'), variant: 'primary', action: SignotecOnOK }
            ]"
        >
            <MdSignotec
                ref="mdSignotec"
                @OnSignotecSubmitImage="SignotecOnSubmitImage"
                @OnSignotecError="SignotecOnError"
                @OnSignotecConfirm="SignotecOnConfirm"
                @OnSignotecCancel="SignotecOnCancel"
            />
        </BaseModal>

        <BaseModal
          v-if="VisibleDrugInteraction"
          ModalId="ModalDrugInteraction"
          :key="'ModalDrugInteraction'"
          :TitleWindow="'Drug Interaction'"
          :width="'70%'"
          :height="'85vh'"
          :UseUpClass="true"
          :HideModalFun="DrugInteractionOnCancel"
          @Close="DrugInteractionOnCancel"
          :buttons="[
              { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }
          ]">

          <DrugInteraction :PatientCode="this.PatientCode"></DrugInteraction>


      </BaseModal>
    </div>
</template>

<script>
import Utils from '@/common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission';
import MedicationService from '@/services/medication.service';
import DocumentManagementService from '@/services/documentmanagement.service';
import PatientService from '@/services/patient.service';
import DrugOrderService from '@/services/drugordersinbox.service';
import EnumService from '@/services/enum.service';
import PharmacyOptions from '@/services/pharmacyoption.service';
import { DxPopup } from 'devextreme-vue/popup';
import DrugOrderNotesDlg from './DrugOrderNotesDlg';
import ModalDrugOrderMedication from '@/components/pages/drugordersinbox/modalDrugOrderViewMedication';
import LetterTemplatesService from '@/services/lettertemplates.service.js';
import ApiService from '@/services/api.service';
import EmployeeService from '@/services/employee.service';
import LocalStorage from '@/services/storage.service';
import DrugInteraction from '@/components/MedEZComponents/DataBank/DrugInteraction';
import qz from 'qz-tray';

export default {
    name: 'DrugOrdersInboxFill',
    mixins: [ShowMessage, Utils, Permission],
    components: { ModalDrugOrderMedication, DxPopup, DrugOrderNotesDlg,DrugInteraction },

    data() {
        return {
            DrugCode: null,
            DrugName: '',
            textEditorVisible: false,
            SearchBank: '',
            FirstDataDrugName: '',
            AdmissionRecordId: null,
            textEditorValue: '',
            DataBankVisible: false,
            PharmacyNoteFill: '',
            isNRC: this.$store.state.companies.isNRC,
            MessageNoFillOrder: null,
            isMedicationLabelsRepVisible: false,
            TitleCondition: '',
            isControlledSubstance: '',
            TotalQtyToFill: 0,
            CanFill: true,
            unitSys: this.$store.state.companies.UnitSystem
                ? this.$store.state.companies.UnitSystem
                : 'U',
            CanCallHeader: false,
            isReadOnly: this.$store.state.isDrugInboxFillEHRReadOnly,
            ReadOnlyByConditions: false,
            VisibleModalViewMed: false,
            reportTitle: this.$t('MdPatientInfoBox.PatientFaceSheet'),
            isReportPatientFaceSheetVisible: false,
            isReportPatientMedicationVisible: false,
            recordsId: [],
            addNoteItem: null,
            pharmacyNoteEditable: true,
            addNoteVisible: false,
            showEmptyRecords: false,
            PharmacyOption: {},
            LocationList: [],
            ModelLocation: { code: '', name: '' },
            ShowText: '',
            posSelected: 0,
            recordIdSelected: '',
            RxStatusList: EnumService.ClinicalMedicatiosRxStatus,
            ModelRxStatus: { value: 'ActiveDuration', name: this.$t('Shared.ActDuration') },
            OrderDetail: [],
            InfoHeader: {},
            recNoToReport: '',
            PatientCode: '',
            PhotoObj: {
                patientPhoto: '',
                patientPhotoExtension: '',
                dob: null,
                patientName: '',
                sex: '',
                marsAlerts: ''
            },
            patientPhoto: '',
            medications: {},
            patientInfo: { contents: null, sex: '', extension: '' },
            parameter: {
                SearchCriteria: ''
            },

            emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },

            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                // patientCode:this.medications.patientCode,
                ItemsList: [],
                favButtonAtion: false
            },

            items2: [],
            fields2: [
                {
                    key: 'startDateTime',
                    sortable: true,
                    label: this.$t('Shared.StartDate'),
                    class: 'text-rigth'
                },
                {
                    key: 'endDateTime',
                    sortable: true,
                    label: this.$t('Shared.EndDate'),
                    class: 'text-rigth'
                },
                { key: 'recordId', sortable: true, label: 'RecordId', class: 'hidden' },
                { key: 'day', sortable: true, label: this.$t('Shared.Days'), class: 'text-rigth' },
                {
                    key: 'drugName',
                    sortable: true,
                    label: this.$t('Shared.DrugName'),
                    class: 'text-rigth'
                },
                {
                    key: 'activeIngredients',
                    sortable: true,
                    label: this.$t('Shared.activeIngredients'),
                    class: 'text-rigth'
                },
                { key: 'sig', sortable: true, label: this.$t('Shared.Sig'), class: 'text-rigth' },
                {
                    key: 'prescriber',
                    sortable: true,
                    label: this.$t('Shared.Prescriber'),
                    class: 'text-rigth'
                },
                //{ key: 'rxStatus', sortable: true, label: this.$t('Medication.RxStatus'), class: 'text-rigth' },
                {
                    key: 'internalStatus',
                    sortable: true,
                    label: this.$t('Shared.InternalStatus'),
                    class: 'text-rigth'
                },
                //{ key: 'quantityOrdered', sortable: true, label: this.$t('Shared.TotalQty'), class: 'text-rigth' },
                {
                    key: 'stopDateTime',
                    sortable: true,
                    label: this.$t('Shared.StopDate'),
                    class: 'text-rigth'
                }
            ],
            totalRows2: 0,
            currentPage2: 1,
            perPage2: 10,
            pageOptions2: [5, 10, 15, 20, 30, 40, 50],
            params2: {
                PatientCode: ''
            },

            items: [],
            totalRows: 0,
            ShowMessageIsEmpty: false,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, 20, 30, 40, 50],
            selected: [],
            indexSelected: 0,
            FieldsDateArr: ['issuedDate'],
            isReportVisible: false,
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',

            SignotecEnabled: false,
            SignotecVisible: false,
            SignotecSignatureFile: null,
            VisibleDrugInteraction:false,
        };
    },

    methods: {
        UpdateDataDrugName(name) {
            this.FirstDataDrugName = name;
        },

        DataBankOnCancel() {
            this.DataBankVisible = false;
        },

        OpenDrugInteraction(){
            this.VisibleDrugInteraction = true;
        },

        DrugInteractionOnCancel(){
            this.VisibleDrugInteraction = false;
        },

        OpenDataBank() {
            this.SearchBank = this.DrugName;
            this.DataBankVisible = true;
        },

        OpenDrugInfo() {
            this.DrugCode = this.medications.drugCode?.trim();
            this.PatientCode = this.medications.patientCode?.trim();
            this.DrugName = this.medications.drugName?.trim();
            if (!this.$store.state.UseFirstDataBank) {
                this.getUrlDrugInfo(this.medications.drugCode);
            } else {
                this.OpenDataBank();
            }
        },

        closeTextEditorHandler() {
            this.textEditorVisible = false;
            this.textEditorValue = '';
        },

        okTextEditorHandler() {
            this.textEditorVisible = false;
            this.textEditorValue = '';
        },

        undoFillOrders() {
            this.$bvModal
                .msgBoxConfirm(this.$t('DrugOrdersInbox.UndoFillOrdersMsg', { label: 1 }), {
                    title: this.$t('DrugOrdersInboxRightBar.Undofillorders'),
                    okTitle: this.$t('DrugOrdersInbox.TitleUndoFillOrder'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        this.$bvModal
                            .msgBoxConfirm(this.$t('DrugOrdersInbox.ConfirmAddNoteMsg'), {
                                title: this.$t('DrugOrdersInboxRightBar.Undofillorders'),
                                okTitle: this.$t('Shared.TitleYes'),
                                cancelTitle: this.$t('Shared.TitleNo'),
                                footerClass: 'p-2',
                                titleClass: 'modal-title modal-type-warning'
                            })
                            .then(value => {
                                if (value) {
                                    this.textEditorValue = '';
                                    this.textEditorVisible = true;
                                } else {
                                    this.undoFillOrdersAsync('');
                                }
                            });
                    }
                });
        },

        undoFillOrdersAsync(note) {
            let params = {
                recordIds: [],
                notes: ''
            };

            params.recordIds.push(this.recordIdSelected.trim());

            params.notes = note;
            this.setUndoOrders(params);
        },

        setUndoOrders(data) {
            DrugOrderService.undoOrders(data)
                .then(response => {
                    if (response.status == '200') {
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.loadFirstItem(this.recordIdSelected);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getRecordId() {
            let recordIdList = [];
            recordIdList.push(this.recordIdSelected);
            return recordIdList;
        },

        OpenMedLabel() {
            this.isMedicationLabelsRepVisible = true;
        },

        closeParamRepWindowMedLabel() {
            this.isMedicationLabelsRepVisible = false;
        },

        UpdateFiledToGive(qtyToFill, qtyAvailable, Id) {
            let arr = this.OrderDetail;
            let total = 0;
            arr.forEach(function(item) {
                total += item.qtyToFill;
            });
            if (qtyToFill <= this.TotalQtyToGive && qtyToFill <= qtyAvailable) {
                this.FilledToGive = total;
            } else {
                document.getElementById(Id).focus();
            }
        },

        setFocus(Id) {
            document.getElementById(Id).focus();
        },

        setValue(Id, val) {
            document.getElementById(Id).value = val;
        },

        UpdateFilled() {
            this.TotalQtyToFill = 0;
            let arr = this.OrderDetail;
            let total = 0;
            arr.forEach(function(item) {
                total += item.qtyToFill;
            });

            this.TotalQtyToFill = total;
        },

        ValidateAll() {
            if (this.TotalQtyToFill < this.InfoHeader.qtyToFill) {
                this.$bvModal
                    .msgBoxConfirm(
                        this.$t('DrugOrdersInbox.MsgPart3') +
                            ' ' +
                            this.TotalQtyToFill +
                            ' ' +
                            this.$t('DrugOrdersInbox.MsgPart4') +
                            ' ' +
                            this.InfoHeader.qtyToFill +
                            ' ' +
                            this.$t('DrugOrdersInbox.MsgPart5'),
                        {
                            title: this.$tc('Shared.Confirm'),
                            okTitle: this.$t('DrugOrdersInboxFill.FillOrder'),
                            cancelTitle: this.$t('Shared.BtnDismiss'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning',
                            id: 'modal_warnMarsFilled'
                        }
                    )
                    .then(async value => {
                        if (value) {
                            this.Fill();
                        }
                    });
            } else if (this.TotalQtyToFill > this.InfoHeader.qtyToFill) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('DrugOrdersInbox.MsgPart1') +
                        ' ' +
                        this.InfoHeader.qtyToFill +
                        ' ' +
                        this.$t('DrugOrdersInbox.MsgPart2') +
                        ' ' +
                        this.TotalQtyToFill +
                        '',
                    'error'
                );
                return;
            } else {
                this.Fill();
            }
        },

        onChangeToFill(Id, item) {
            if (item.qtyToFill < 0) {
                this.setFocus(Id);
                item.qtyToFill = 0;
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('DrugOrdersInbox.QtyToFill'),
                    'error'
                );
                return;
            }
        },

        blurQTYToFill(qtyToFill, qtyAvailable, Id, item) {
            if (qtyToFill > qtyAvailable) {
                this.setFocus(Id);
                item.qtyToFill = 0;
                // item.qtyToFill = this.InfoHeader.qtyToFill;
                // this.setValue(Id,this.TotalQtyToFill);    this.$t('DrugOrdersInbox.MsgPart5')
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('DrugOrdersInbox.OrderingQuantityExceedAvail'),
                    'error'
                );
                return;
            }

            if (qtyToFill > this.InfoHeader.qtyToFill) {
                this.setFocus(Id);
                item.qtyToFill = 0;
                // item.qtyToFill = this.InfoHeader.qtyToFill;
                //  this.setValue(Id,this.TotalQtyToFill);
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('DrugOrdersInbox.OrderingQuantityExceedFill'),
                    'error'
                );
                return;
            }

            this.UpdateFilled();
            //this.UpdateFiledToGive(qtyToFill,qtyAvailable,Id);
        },

        okHandler() {
            this.addNoteVisible = false;
            this.pharmacyNoteEditable = true;
            this.addNoteItem = null;
        },

        closeHandler() {
            this.addNoteVisible = false;
        },

        setStatusUnableToFillHandler(pharmacistNotes) {
            let params = {
                recordIds: [],
                status: '',
                pharmacistNotes: ''
            };
            params.status = 'UNABLETOFILL';
            params.recordIds.push(this.recordIdSelected);
            params.pharmacistNotes = pharmacistNotes;
            this.setStatus(params);
        },

        AddingNotes() {
            this.pharmacyNoteEditable = true;
            this.addNoteItem = { recordId: this.recordIdSelected };
            this.addNoteVisible = true;
        },

        updateChargeable(status) {
            let params = {
                recordIds: [],
                chargeable: status === status
            };
            params.recordIds.push(this.recordIdSelected);

            this.updateChargeableAsync(params);
        },

        updateChargeableAsync(data) {
            DrugOrderService.UpdateChargeable(data)
                .then(response => {
                    if (response.status == '200') {
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );

                        this.updatesCall();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getUrlDrugInfo() {
            MedicationService.getUrlDrugInfo(this.medications.drugCode)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        window.open(response.data.url, '_blank');
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        SetStatusHandler(status) {
            if (status == 'UNABLETOFILL') {
                this.pharmacyNoteEditable = false;
                this.addNoteItem = { recordId: this.recordIdSelected };
                this.addNoteVisible = true;
            } else {
                let params = {
                    recordIds: [],
                    status: '',
                    pharmacistNotes: ''
                };
                params.status = status;
                params.recordIds.push(this.recordIdSelected);
                this.setStatus(params);
            }
        },

        setStatus(data) {
            DrugOrderService.UpdateStatus(data)
                .then(async response => {
                    if (response.status == '200') {
                        if (data.recordIds.length === response.data.affectedRows) {
                            setTimeout(
                                () =>
                                    this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                        title: this.$t('Msg.Success'),
                                        autoHideDelay: 5000,
                                        variant: 'success'
                                    }),
                                50
                            );
                        } else {
                            setTimeout(
                                () =>
                                    this.$bvToast.toast(
                                        response.data.affectedRows +
                                            ' ' +
                                            this.$t('MdGenericOutCome.OutOf') +
                                            ' ' +
                                            data.recordIds.length +
                                            ' ' +
                                            this.$t('DrugOrdersInbox.ItemsAffected'),
                                        {
                                            title: this.$tc('Msg.Warning', 1),
                                            autoHideDelay: 5000,
                                            variant: 'warning'
                                        }
                                    ),
                                50
                            );
                        }

                        this.updatesCall();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        ValidateState(state) {
            return this.medications.internalStatus?.toUpperCase() === state.toUpperCase();
        },

        ValidateRxStatus(status) {
            return this.medications.rxStatus?.toUpperCase() === status.toUpperCase();
        },

        PatientOwnMedication() {
            return this.medications.isPatientOwnMedication;
        },

        popupAttributes() {},

        ValidateNoChargeable() {
            return this.medications.chargeable;
        },

        ValidateVoided() {
            return this.medications.internalStatus?.toUpperCase() !== 'VOIDED';
        },

        onHiddenMedicationReport() {
            this.isReportPatientMedicationVisible = false;
        },

        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0];
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px';
        },

        onHiddenReport() {
            this.isReportPatientFaceSheetVisible = false;
        },

        closeParamRepWindow() {
            this.isReportVisible = false;
            this.recNoToReport = '';
        },

        async Back() {
            if (this.posSelected > 0) {
                this.posSelected -= 1;
                this.recordIdSelected = this.recordsId[this.posSelected];
                this.ShowText =
                    this.$t('Shared.Showing') +
                    ' ' +
                    (this.posSelected + 1) +
                    ' ' +
                    this.$t('Shared.Of') +
                    ' ' +
                    this.recordsId.length;

                await this.loadFirstItem(this.recordsId[this.posSelected]);
            }
        },

        async Next() {
            if (this.posSelected <= this.recordsId.length - 1) {
                this.posSelected += 1;
                this.recordIdSelected = this.recordsId[this.posSelected];
                this.ShowText =
                    this.$t('Shared.Showing') +
                    ' ' +
                    (this.posSelected + 1) +
                    ' ' +
                    this.$t('Shared.Of') +
                    ' ' +
                    this.recordsId.length;
                await this.loadFirstItem(this.recordsId[this.posSelected]);
            }
        },

        goBack() {
            this.$router.push({ name: 'DrugOrdersInbox' });
        },

        Fill() {
            if (this.SignotecEnabled == false || this.SignotecSignatureFile) {
                this.FillOrder();
            } else {
                this.SignotecVisible = true;
            }
        },

        GotoMedByBox() {
            this.RecordId = this.recordIdSelected;
            this.VisibleModalViewMed = true;
        },

        ViewMed(item) {
            this.RecordId = item.recordId;
            //this.PatientCode = item.patientCode ? item.patientCode.trim():null;
            this.VisibleModalViewMed = true;
        },

        CloseModalMed() {
            this.VisibleModalViewMed = false;
        },

        Print() {
            let reportParams = [];
            reportParams.push({ paramName: 'patientCode', paramValue: this.PatientCode ?? null });
            reportParams.push({ paramName: 'recNo', paramValue: this.recordIdSelected ?? null });
            reportParams.push({
                paramName: 'isControlledSubstance',
                paramValue: this.medications.drugTypeCode ?? null
            });
            reportParams.push({ paramName: 'isUAE', paramValue: this.isNRC });
            this.isReportPatientMedicationVisible = true;
            this.$refs.patientMedications.buildDocument(reportParams);
        },

        DoReport() {
            let reportParams = [];

            reportParams.push({ paramName: 'PatientCodeList', paramValue: this.PatientCode });
            reportParams.push({ paramName: 'ActivePatient', paramValue: '' });
            reportParams.push({ paramName: 'ActiveAdmission', paramValue: '' });

            this.isReportPatientFaceSheetVisible = true;
            this.$refs.PatientFaceSheetRep.buildDocument(reportParams);
        },

        ChangeDropDownRxStatus(v) {
            this.ModelRxStatus = v !== null ? v : { value: 'All', name: this.$t('Shared.All') };
            this.getPatientMedications2(this.medications.patientCode);
        },

        onFiltered2(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        onRowSelected(item) {
            this.selected = item;
        },

        onRowSelected2(item) {
            this.selected = item;
        },

        RowClicked() {},

        pageChanged2(page) {
            this.currentPage = page;
        },

        pageChanged(page) {
            this.currentPage = page;
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
        },

        PerPageFunction2(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        ChangeDropDownLocation(item) {
            this.ModelLocation = item ? item : { code: '', name: '' };
            this.getFillHeader(
                this.medications.drugCode,
                this.recordIdSelected,
                this.ModelLocation.code
            );
            this.getFillDetail(
                this.medications.drugCode,
                this.recordIdSelected,
                this.ModelLocation.code,
                this.InfoHeader.qtyToFill
            );
        },

        label(value) {
            if (value === 'Temperature') {
                return this.unitSys === 'U' ? ' (°F)' : ' (°C)';
            }

            if (value === 'Weightlbs') {
                return this.unitSys === 'U' ? ' (lbs)' : ' (Kgs)';
            }

            if (value === 'Weightoz') {
                return this.unitSys === 'U' ? ' (oz)' : ' (g)';
            }

            if (value === 'Heightft' || value === 'HeadCirin') {
                return this.unitSys === 'U' ? ' (ft)' : ' (cm)';
            }

            if (value === 'Heightin') {
                return this.unitSys === 'U' ? ' (in)' : ' (mm)';
            }

            if (value === 'SugarLevelmgdL') {
                return this.unitSys === 'U' ? ' (mg/dL)' : ' (mM)';
            }

            if (value === 'BMIlbsin2') {
                return this.unitSys === 'U' ? ' (lbs/in2)' : ' (kgs/m2)';
            }

            return '';
        },

        ShowReport(item) {
            if (item) {
                if (item && item.recordId) {
                    this.recNoToReport = item.recordId;
                }
                this.isReportVisible = true;
            } else {
                setTimeout(
                    () =>
                        this.$bvToast.toast(this.$t('MdTable.nRecShow'), {
                            title: this.$t('Msg.Info'),
                            autoHideDelay: 3000,
                            variant: 'info'
                        }),
                    50
                );
            }
        },

        onRowClicked(item, index) {
            this.indexSelected = index;

            if (item.selected) {
                this.$set(item, 'selected', false);
            } else {
                this.$set(item, 'selected', true);
            }
        },

        async getPatientInfo(patientCode) {
            await PatientService.get(patientCode)
                .then(response => {
                    if (response.data) {
                        this.patientInfo = response.data;
                        this.patientInfo.contents = this.patientPhoto.contents;
                        this.patientInfo.extension = this.patientPhoto.extension;

                        this.patientInfo.patientName =
                            this.patientInfo.firstname + ' ' + this.patientInfo.lastname;
                        this.patientInfo.dob = Utils.formatterDateToString(this.patientInfo.dob);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async CanFillOrder() {
            await DrugOrderService.CanFillOrder(false, this.recordIdSelected)
                .then(response => {
                    if (response.data) {
                        this.CanFill = response.data.result;
                        this.MessageNoFillOrder = response.data.message;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPatientPhoto(patientCode) {
            await DocumentManagementService.GetPatientPhoto(patientCode)
                .then(response => {
                    if (response.data) {
                        this.patientPhoto = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPatientMedications2(patientCode) {
            var params2 = {
                PatientCode: patientCode,
                Status: this.ModelRxStatus.value,
                PageNumber: this.currentPage2,
                PageSize: this.perPage2,
                SearchCriteria: this.parameter.SearchCriteria ? this.parameter.SearchCriteria : '',
                buildingRestriction: this.$store.state.restrictions.buildingLocation
            };
            await MedicationService.getAll(params2)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items2 = response.data;
                        this.totalRows2 = this.items2.length > 0 ? this.items2[0].maxRows : 0;
                        this.items2.forEach(function(item) {
                            if (item.startDateTime)
                                item.startDateTime = Utils.formatterDateTimeToString(
                                    item.startDateTime
                                );
                            if (item.endDateTime)
                                item.endDateTime = Utils.formatterDateTimeToString(
                                    item.endDateTime
                                );
                            if (item.stopDateTime)
                                item.stopDateTime = Utils.formatterDateTimeToString(
                                    item.stopDateTime
                                );
                        });
                        if (this.items2.length === 0) {
                            this.ShowMessageIsEmpty = true;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPatientMedications(id) {
            await MedicationService.get(id)
                .then(response => {
                    if (response.data) {
                        this.medications = response.data;
                        this.isControlledSubstance = this.medications.drugTypeCode;
                        this.PatientCode = this.medications.patientCode;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getDescriptionByCode(arr, code) {
            let description = '';
            if (arr.length > 0) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].code && arr[i].code.trim() === code) {
                        description = arr[i].name;
                        break;
                    }
                }
            }
            return description;
        },

        IsLocationsinList(arr, code) {
            arr.forEach(element => {
                element.code = element.code?.trim();
            });

            return arr.find(u => u.code.includes(code));
        },

        async getDrugOrderLocations() {
            await DrugOrderService.getLocations({ useEmployeeRestriction: true })
                .then(response => {
                    if (response.data) {
                        this.LocationList = response.data;
                        if (
                            this.IsLocationsinList(
                                this.LocationList,
                                this.PharmacyOption.defaultLocation?.toString()
                            )
                        ) {
                            this.ModelLocation.code = this.PharmacyOption.defaultLocation
                                ? this.PharmacyOption.defaultLocation?.trim()
                                : '';
                            this.ModelLocation.name = this.getDescriptionByCode(
                                this.LocationList,
                                this.PharmacyOption.defaultLocation
                            );
                        } else {
                            if (this.LocationList.length > 0) {
                                this.ModelLocation.code = this.LocationList[0].code?.trim();
                                this.ModelLocation.name = this.LocationList[0].name?.trim();
                            }
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getFillHeader(DrugCode, RecordId, location) {
            await DrugOrderService.getOrderHeader(DrugCode, RecordId, location)
                .then(response => {
                    if (response.data) {
                        this.InfoHeader = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getFillDetail(DrugCode, RecordId, location, qtyToFill) {
            await DrugOrderService.getOrderDetails(DrugCode, RecordId, location, qtyToFill)
                .then(response => {
                    if (response.data) {
                        this.OrderDetail = response.data;
                        this.showEmptyRecords = this.OrderDetail.length === 0 ? true : false;
                        let total = 0;
                        this.OrderDetail.forEach(function(item) {
                            item.max = item.qtyToFill?.toString();
                            if (item.expirationDate)
                                item.expirationDate = Utils.formatterDateToString(
                                    item.expirationDate
                                );

                            total += item.qtyToFill;
                        });

                        this.TotalQtyToFill = total;

                        if (this.OrderDetail.length === 0) {
                            this.TotalQtyToFill = 0;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async searchItems(recordId, location) {
            await DrugOrderService.getReturnedItems({
                recordId: recordId,
                location: location?.trim()
            })
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.pendingChanges = false;
                        this.OrderDetail = response.data.map(item => {
                            return {
                                ...item,
                                expirationDate: Utils.formatterDateToString(item.expirationDate),
                                qtyToReturn: 0,
                                remarks: ''
                            };
                        });

                        this.showEmptyRecords = this.OrderDetail.length === 0;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPharmacyOptions() {
            await PharmacyOptions.getPharmacyOptions()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.PharmacyOption = response.data[0];
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        PrepareFill(arr) {
            let arrtest = JSON.parse(JSON.stringify(arr));
            arrtest.forEach(element => {
                element.expirationDate = Utils.formatterToISO(
                    element.expirationDate,
                    Utils.getShortDateFormat()
                );
            });
            return arrtest;
        },

        MessageSuccess(messageLevel) {
            if (messageLevel === null || messageLevel === '') {
                setTimeout(
                    () =>
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: 'success'
                        }),
                    50
                );
            } else {
                setTimeout(
                    () =>
                        this.$bvToast.toast(messageLevel, {
                            title: this.$tc('Msg.Warning', 1),
                            autoHideDelay: 5000,
                            variant: 'warning'
                        }),
                    50
                );
            }
        },

        async FillOrder() {
            let data = {
                IsMars: false,
                recordID: this.recordIdSelected,
                QTYAvial: this.InfoHeader.qtyAvailable,
                QTYFilled: this.TotalQtyToFill,
                Notes: this.PharmacyNoteFill,
                orderDetails: this.PrepareFill(this.OrderDetail),
                signature: this.SignotecSignatureFile
            };
            await DrugOrderService.FillOrder(data)
                .then(response => {
                    if (response.status == '200') {
                        if (response.data && response.data.result) {
                            // print, if pharmacy options set, api has certificate setup and qz available
                            if (this.PharmacyOption.printAfterFillOrder) {
                                this.getMedLabelPdf(this.recordIdSelected);
                            }
                            if (this.posSelected === this.recordsId.length - 1) {
                                this.$router.push({ name: 'DrugOrdersInbox' });
                            }

                            if (this.posSelected < this.recordsId.length - 1) {
                                this.Next();
                            }

                            this.MessageSuccess(response.data.reorderLevelMessage);
                        } else {
                            this.showMessage(this.$tc('Msg.Error'), response.data.message, 'error');
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async updatesCall() {
            await this.getPatientMedications(this.recordIdSelected);
            await this.CanFillOrder();

            if (this.CanFill) {
                await this.getFillHeader(
                    this.medications.drugCode,
                    this.recordIdSelected,
                    this.ModelLocation.code
                );
                this.getFillDetail(
                    this.medications.drugCode,
                    this.recordIdSelected,
                    this.ModelLocation.code,
                    this.InfoHeader.qtyToFill
                );
            } else {
                if (
                    this.medications.internalStatus &&
                    this.medications.internalStatus?.toUpperCase() === 'FILLED'
                ) {
                    this.searchItems(this.recordIdSelected, this.ModelLocation.code);
                } else {
                    this.OrderDetail = [];
                    this.showEmptyRecords = true;
                }
            }
        },

        async loadFirstItem(id) {
            await this.getPharmacyOptions();
            await this.getDrugOrderLocations();
            await this.getPatientMedications(id);
            await this.CanFillOrder();

            if (this.CanFill) {
                await this.getFillHeader(this.medications.drugCode, id, this.ModelLocation.code);
                this.getFillDetail(
                    this.medications.drugCode,
                    id,
                    this.ModelLocation.code,
                    this.InfoHeader.qtyToFill
                );
            } else {
                if (
                    this.medications.internalStatus &&
                    this.medications.internalStatus?.toUpperCase() === 'FILLED'
                ) {
                    this.searchItems(id, this.ModelLocation.code);
                } else {
                    this.OrderDetail = [];
                    this.showEmptyRecords = true;
                }
            }

            await this.getPatientPhoto(this.medications.patientCode);
            await this.getPatientInfo(this.medications.patientCode);

            await this.getPatientMedications2(this.medications.patientCode);
        },

        async getMedLabelPdf(id) {
            await LetterTemplatesService.getMedLabelPdf('MEDLABEL', id)
                .then(response => {
                    if (response.status == '200' && response.data && response.data.done) {
                        this.printData = response.data;
                        this.printPrescription(this.printData.url, this.printData.printerName);
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async printPrescription(URL, printerName) {
            let aPrinterName = printerName;
            let isPrintExist = true;

            let baseurl = this.$store.state.apiurl.replace('/api/', '');

            if (qz && qz.log) {
                qz.log.setLevel('silent');
            }

            if (!qz.websocket.isActive()) {
                try {
                    qz.security.setCertificatePromise(function(resolve, reject) {
                        ApiService.get('/qztray/certificate').then(function(response) {
                            response.status == '200'
                                ? resolve(response.data)
                                : reject(response.data);
                        });
                    });

                    qz.security.setSignatureAlgorithm('SHA256');

                    qz.security.setSignaturePromise(function(toSign) {
                        return function(resolve, reject) {
                            ApiService.post('/qztray/sign', toSign).then(function(response) {
                                response.status == '200'
                                    ? resolve(response.data)
                                    : reject(response.data);
                            });
                        };
                    });

                    await qz.websocket.connect({
                        host: 'localhost',
                        usingSecure: true
                    });
                    if (!aPrinterName) {
                        await qz.printers
                            .getDefault()
                            .then(printerName => {
                                aPrinterName = printerName;
                            })
                            .catch(() => {
                                this.showMessage(
                                    this.$t('QZTray.ErrorTitle'),
                                    this.$t('QZTray.ErrorDefaultPrinter'),
                                    'error'
                                );
                            });
                    } else {
                        await qz.printers
                            .find()
                            .then(printers => {
                                let exist = printers.includes(aPrinterName);
                                if (!exist) {
                                    isPrintExist = false;
                                    this.showMessage(
                                        this.$t('QZTray.ErrorTitle'),
                                        this.$t('QZTray.PrinterNotExist'),
                                        'error'
                                    );
                                }
                            })
                            .catch(() => {
                                this.showMessage(
                                    this.$t('QZTray.ErrorTitle'),
                                    this.$t('QZTray.ErrorPrintList'),
                                    'error'
                                );
                            });
                    }
                } catch (err) {
                    this.showMessage(
                        this.$t('QZTray.ErrorTitle'),
                        this.$t('QZTray.ErrorMessage'),
                        'warning'
                    );
                }
            }

            if (isPrintExist && qz.websocket.isActive()) {
                const config = qz.configs.create(aPrinterName);

                const data = [
                    {
                        type: 'pixel',
                        format: 'pdf',
                        flavor: 'file',
                        data: baseurl + URL
                    }
                ];

                await qz.print(config, data);

                this.showMessage(
                    this.$t('Msg.Info'),
                    this.$t('QZTray.SendingToPrinter') + ': ' + aPrinterName,
                    'success'
                );
            }

            if (qz.websocket.isActive()) {
                await qz.websocket.disconnect();
            }
        },

        SignotecOnOK() {
            if (!this.SignotecSignatureFile) {
                this.$refs.mdSignotec.confirm();
            }
        },

        SignotecOnCancel() {
            this.SignotecVisible = false;
            this.SignotecSignatureFile = null;
        },

        SignotecOnConfirm() {
            if (this.SignotecSignatureFile) {
                this.SignotecVisible = false;
                this.FillOrder();
            } else {
                this.showMessage(this.$tc('Msg.Error'), 'Please sign', 'error');
            }
        },

        SignotecOnSubmitImage(data) {
            this.SignotecSignatureFile = data;
        },

        SignotecOnError(msg) {
            this.showMessage(this.$tc('Msg.Error'), msg, 'error');
        }
    },

    async mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;
        this.OptionsRightMenu.ItemsList = [];

        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);

        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        const UserId = LocalStorage.getUserId();
        EmployeeService.GetByUserId(UserId)
            .then(response => {
                if (response.data) {
                    let result = response.data;
                    if (
                        result &&
                        result.requestSigFillOrders &&
                        result.signaturePad == 'Signotec'
                    ) {
                        this.SignotecEnabled = true;
                    }
                }
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    async created() {
        const stored = sessionStorage.getItem('DrugOrdersValidationRecordsId');
        this.posSelected = 0;
        if (stored) {
            this.recordsId = JSON.parse(stored);
            this.recordIdSelected = this.recordsId[0];
            this.ShowText =
                this.$t('Shared.Showing') +
                ' ' +
                (this.posSelected + 1) +
                ' ' +
                this.$t('Shared.Of') +
                ' ' +
                this.recordsId.length;
            await this.loadFirstItem(this.recordsId[0]);
        }
    }
};
</script>
